// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { useMutation, useRequest } from "redux-query-react";
import { createSelector } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import * as QueryString from 'query-string';
import { isEqual } from "lodash";
import * as runtime from '../runtime';
import { objectToHash } from "common/object-helper";
import { PmiAssociationFromJSON, PmiAssociationToJSON, } from '../models';
/**
 * List pmi associations
 * Get PMI associations
 */
export function getPmiAssociationsRaw(requestParameters, requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    queryParameters = {};
    if (requestParameters.entityId !== undefined) {
        queryParameters['entityId'] = requestParameters.entityId;
    }
    queryString = `?${QueryString.stringify(queryParameters)}`;
    if (requestParameters.entityType !== undefined) {
        queryParameters['entityType'] = requestParameters.entityType;
    }
    queryString = `?${QueryString.stringify(queryParameters)}`;
    const headerParameters = {};
    const { meta = {} } = requestConfig;
    const config = {
        url: runtime.BASE_PATH + `/pmiassociations` + queryString,
        meta,
        update: requestConfig.update || {
            PmiAssociations: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'GET',
            headers: headerParameters,
        },
        body: queryParameters,
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = body.map(PmiAssociationFromJSON);
            return {
                PmiAssociations: objResponse.reduce((map, obj) => {
                    map[obj.id] = obj;
                    return map;
                }, {})
            };
        }
    };
    config.queryKey = requestConfig.queryKey || `GetPmiAssociations-${objectToHash(requestParameters)}`;
    return config;
}
/**
* List pmi associations
* Get PMI associations
*/
/**
 * Use this selectors to get a record of all Array<PmiAssociation>, with their ids as keys
 * @returns A record of Array<PmiAssociation> object, with their ids as keys
 */
export const usePmiAssociationsRecordSelector = () => useSelector((state) => state.entities.PmiAssociations, isEqual);
const PmiAssociationsArraySelector = createSelector((state) => state.entities.PmiAssociations, (selectedSubState) => Object.keys(selectedSubState).map((id) => selectedSubState[id]));
/**
 * Use this selector to get a reference to a flat Array<PmiAssociation>.
 * If you are doing transformation on this object, consider using usePmiAssociationsRecordSelector instead for performances
 * @returns An array containing all loaded PmiAssociations
 */
export const usePmiAssociationsArraySelector = () => useSelector(PmiAssociationsArraySelector, isEqual);
/**
 * Request hook for Array<PmiAssociation>
 * @param customQueryConfig TypedQueryConfig options set here will override default options.
 * @returns an array containg the data, query status, and a call for refresh
 * (note : refresh shouldn't be necessary, update to the state should be handle by mutators)
 */
export const useGetPmiAssociations = (requestParameters, customQueryConfig) => {
    const [querystate, forceRefresh] = useRequest(getPmiAssociationsRaw(requestParameters, customQueryConfig));
    return [
        usePmiAssociationsArraySelector(),
        querystate,
        forceRefresh
    ];
};
export function getPmiAssociations(requestParameters, requestConfig) {
    return getPmiAssociationsRaw(requestParameters, requestConfig);
}
/**
 * Upsert PMI associations for specific entity
 * Upsert PMI associations
 */
export function postPmiAssociationsRaw(requestParameters, requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    headerParameters['Content-Type'] = 'application/json';
    const { meta = {} } = requestConfig;
    const config = {
        url: runtime.BASE_PATH + `/pmiassociations` + queryString,
        meta,
        update: requestConfig.update || {
            PmiAssociations: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'POST',
            headers: headerParameters,
        },
        body: requestParameters.pmiAssociation?.map(PmiAssociationToJSON),
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = body.map(PmiAssociationFromJSON);
            return {
                PmiAssociations: objResponse.reduce((map, obj) => {
                    map[obj.id] = obj;
                    return map;
                }, {})
            };
        }
    };
    config.queryKey = requestConfig.queryKey || `PostPmiAssociations-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Upsert PMI associations for specific entity
* Upsert PMI associations
*/
/**
 * Mutation hook to create a Client
 * @param customQueryConfig TypedQueryConfig options set here will override default options.
 * @returns [QueryState, RunMutation] queryState and an async call to upsert an array client
 */
export const usePostPmiAssociations = (customQueryConfig) => {
    return useMutation((pmiAssociation, customQueryParam) => postPmiAssociationsRaw({ pmiAssociation }, { ...customQueryConfig, meta: { ...customQueryConfig?.meta, ...customQueryParam } }));
};
export function postPmiAssociations(requestParameters, requestConfig) {
    return postPmiAssociationsRaw(requestParameters, requestConfig);
}
